import React from "react";
import { withStyles } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Menu from "@material-ui/core/Menu";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";

const color = {
  ModalBGColorDark: "#2C353E",
  ModalBGColorLight: "#FFFFFF",
  labelColorDark: "#CDCDCD",
  labelColorLight: "666666",
  radioColor: "#05A792",
};
const styles = {
  radioLabel: {
    height: "12px",
    fontSize: "18px",
  },
  label_dark: {
    color: color.labelColorDark,
    fontWeight: 600,
    fontSize: 12,
  },
  label_light: {
    color: color.labelColorLight,
    fontWeight: 600,
    fontSize: 12,
  },
  radioRoot: {
    width: "10px",
    color: color.radioColor,
    height: "10px",
    fontSize: "18px",
  },
  noOptions: {
    padding: "18px",
    color: color.radioColor,
    fontSize: 12,
  },
  terminalClicked_light: {
    padding: "10px 17px",
    backgroundColor: color.ModalBGColorLight,
  },
  terminalClicked_dark: {
    padding: "10px 17px",
    backgroundColor: color.ModalBGColorDark,
  },
  terminalMenu_dark: {
    background: color.ModalBGColorDark,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "10px",
    marginLeft: "12px",
    maxHeight: 320,
  },
  terminalMenu_light: {
    background: color.ModalBGColorLight,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "10px",
    marginLeft: "12px",
    maxHeight: 320,
  },
};

const SelectPickupTerminal = ({
  classes,
  terminalAnchor,
  closeTerminalMenu,
  terminalOptions,
  activeTerminal,
  handleTerminalChange,
  theme,
}) => {
  const changeTerminal = (event) => {
    handleTerminalChange(event.target.value);
  };
  return (
    <Menu
      disablePortal={false}
      getContentAnchorEl={null}
      disableAutoFocusItem={true}
      anchorReference="anchorPosition"
      anchorPosition={{ top: 42, left: 16 }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={true}
      container={terminalAnchor}
      onClose={closeTerminalMenu}
      MenuListProps={{ disablePadding: true }}
      classes={{
        paper: classes[`terminalMenu_${theme}`],
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
        {terminalOptions.length ? (
          terminalOptions.map((terminalCode) => (
            <ListItem
              key={terminalCode}
              classes={{ root: classes[`terminalClicked_${theme}`] }}
              disableGutters
            >
              <RadioGroup
                aria-label="Terminal"
                name="terminal"
                value={activeTerminal}
                onChange={(event) => changeTerminal(event)}
              >
                <FormControlLabel
                  classes={{
                    root: classes.radioLabel,
                    label: classes[`label_${theme}`],
                  }}
                  value={terminalCode}
                  control={
                    <Radio
                      color={color.radioColor}
                      classes={{ root: classes.radioRoot }}
                      icon={<RadioButtonUncheckedIcon fontSize="small" />}
                      checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
                    />
                  }
                  label={terminalCode}
                />
              </RadioGroup>
            </ListItem>
          ))
        ) : (
          <div className={classes.noOptions}>No Data Available</div>
        )}
    </Menu>
  );
};

export default withStyles(styles)(SelectPickupTerminal);
